import { render } from "./EmployeeFormModal.vue?vue&type=template&id=2a80a99e"
import script from "./EmployeeFormModal.vue?vue&type=script&lang=ts"
export * from "./EmployeeFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script